<template>
  <v-expansion-panels class="mb-4">
    <v-expansion-panel>
      <v-expansion-panel-header>Tìm kiếm theo báo cáo thành tích cá nhân</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card class="ma-0 overflow-visible" outlined>
          <validation-observer v-slot="{ handleSubmit }">
            <v-list-item class="pa-0" three-line>
              <v-list-item-content class="overflow-visible pa-0">
                <v-row>
                  <v-col cols="12" sm="6">
                    <validation-provider name="Nhân viên" v-slot="{ errors }" rules="required">
                      <common-select-user
                        v-model="filterForm.userId"
                        :items="users"
                        label="Tìm kiếm nhân viên *"
                        placeholder="Chọn nhân viên"
                        item-text="fullName"
                        item-value="id"
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <validation-provider name="Chọn ngày" v-slot="{ errors }" rules="required">
                      <common-range-picker
                        v-model="selectRange"
                        :aLight="'center'"
                        :clearable="true"
                        :defaultRange="defaultRange"
                        @change-date-range="changeDateRange"
                      />
                      <div class="v-text-field__details mt-1">
                        <div class="v-messages theme--light error--text" role="alert">
                          <div class="v-messages__wrapper">
                            <div class="v-messages__message">{{ errors[0] }}</div>
                          </div>
                        </div>
                      </div>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      v-model="filterForm.shift"
                      :items="shiftListReport"
                      label="Tìm kiếm theo ca làm việc"
                      placeholder="Ca làm việc"
                      item-text="text"
                      item-value="value"
                      clearable
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-autocomplete
                      v-model="filterForm.storeId"
                      :items="stores"
                      label="Tìm kiếm theo kho"
                      placeholder="Chọn kho"
                      item-text="label"
                      item-value="value"
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <div class="text-center mb-4">
                  <v-btn class="primary mx-0" @click.prevent="handleSubmit(searchReport);">
                    <v-icon>mdi-magnify</v-icon>Tìm kiếm
                  </v-btn>
                </div>
              </v-list-item-content>
            </v-list-item>
          </validation-observer>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
import RepositoryFactory from '@/repositories/RepositoryFactory';
import { shiftListReport } from '../../../../helpers/constants';
import * as moment from 'moment';
const OrganizationMachineRepository = RepositoryFactory.get('organization_machine')
export default {
  name: 'FilterForm',
  props: {
    filterForm: {
      default: () => ({})
    },
    stores: {
      type: Array,
      default: () => {[]}
    }
  },
  data() {
    return {
      shiftListReport,
      users: [],
      defaultRange: {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
      },
      selectRange: [
        {
          startDate: moment().format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD')
        }
      ],
      watchModule: ''
    };
  },
  created() {
    this.getUsers();
    this.watchModule = this.$store.watch(
      (state) => {
        return state.module
      },
      (newVal) => {
        this.getUsers()
      },
      {
        deep: true
      }
    )
  },
  beforeDestroy() {
    this.watchModule()
  },
  methods: {
    changeDateRange(dateRange) {
      this.filterForm.dateRange = dateRange;
      this.selectRange = dateRange;
    },
    searchReport() {
      Bus.$emit('staff-filter-list-fe', this.filterForm, this.users.find(u => u.id === this.filterForm.userId));
    },
    async getUsers() {
      // const res = await OrganizationMachineRepository.listUserV4({
      //   status: 'active',
      //   schoolLevelId: this.$store.state.module.schoolLevelId,
      //   typeId: this.$store.state.module.typeId
      // })

      // Danh sách user theo bộ phận cấp 2
      const res = await OrganizationMachineRepository.listUserContactAdviseLevel2({
        status: 'active',
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      })

      if (res.success) {
        let listUsers = _.get(res, 'data', [])
        const groupUsers = [];
        listUsers.forEach(ministry => {
          const { users = [] } = ministry;
          if (users.length) {
            groupUsers.push({
              header: ministry.name,
              name: _.get(ministry, 'name'),
              ministryId: ministry.id,
            });
            users.forEach(user => {
              groupUsers.push({
                fullName: _.get(user, 'fullName'),
                group: _.get(ministry, 'name'),
                id: user.id,
                avatar: _.get(user, 'avatar.filePath'),
                ministryId: ministry.id,
              });
            });
          }
        });
        this.users = groupUsers;
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
    },
  }
};
</script>
